module.exports = __webpack_public_path__ + "media/images/admin/icons/rewind-61a158c0eeca9fa6bc70f5956cc953e5.svg";